import PropTypes from "prop-types";
import {Avatar, Card, CardContent, Stack, SvgIcon, Typography} from "@mui/material";
import {AssignmentTurnedIn} from "@mui/icons-material";

export const ActiveDeliveryOrders = (props) => {
    const {sx, value} = props;

    return (
        <Card sx={sx}>
            <CardContent>
                <Stack
                    alignItems="flex-start"
                    direction="row"
                    justifyContent="space-between"
                    spacing={3}
                >
                    <Stack spacing={1}>
                        <Typography color="text.secondary" variant="overline">
                            Pending delivery orders
                        </Typography>
                        <Typography variant="h5">{value}</Typography>
                    </Stack>

                    <Avatar
                        sx={{
                            backgroundColor: "success.main",
                            height: 56,
                            width: 56,
                        }}
                    >
                        <SvgIcon>
                            <AssignmentTurnedIn/>
                        </SvgIcon>
                    </Avatar>
                </Stack>
            </CardContent>
        </Card>
    );
};

ActiveDeliveryOrders.prototypes = {
    difference: PropTypes.number,
    positive: PropTypes.bool,
    sx: PropTypes.object,
    value: PropTypes.string.isRequired,
};
